import { TimesheetPageEmployeesSettingFragment } from 'generated/resources/graphql'

export const shouldHideLocationColumn = (
  attendanceSetting?: TimesheetPageEmployeesSettingFragment
) => {
  if (attendanceSetting?.enableClockInLocation) {
    if (attendanceSetting?.geolocation) return false
  } else {
    if (!attendanceSetting?.geolocation) return true
  }

  return false
}

export const getColSpan = (
  hasProjects: boolean,
  hideLocationColumn: boolean,
  hasCorrectiveBreaks: boolean,
  hasExtraHourManagementV2: boolean,
  showExtraHoursColumn: boolean
): number => {
  let baseColSpan = 4

  if (!hideLocationColumn) {
    baseColSpan += 1
  }

  if (hasProjects) {
    baseColSpan += 1
  }

  if (hasCorrectiveBreaks) {
    baseColSpan += 1
  }

  if (hasExtraHourManagementV2) {
    baseColSpan += 1
  }

  if (showExtraHoursColumn) {
    baseColSpan += 1
  }

  return baseColSpan
}
